module.exports = __webpack_public_path__ + "img/解答之書介紹icon.9c12fecd.svg";